import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  getActiveUser,
  getActiveSchoolLicense,
  getFailedLoginErrorVars,
} from 'Store/reducers';
import { sendAnalyticsEventById } from 'Store/stats/actions';
import { getPlanByLicense, pricingOptions } from 'Settings/pricing-options';

import ContentFrame from 'Components/ContentFrame';
import PageHeader from 'Components/PageHeader';
import PricingGrid from 'Components/PricingGrid';
import PricingFeatures from 'Components/PricingFeatures';
import ConnectedFormattedMessage from 'Containers/ConnectedFormattedMessage';

class PricingPage extends React.PureComponent {
  componentDidMount() {
    if (this.props.activeUser)
      this.props.sendAnalyticsEventById('viewed_pricing_grid');
  }

  render() {
    const {
      plan,
      location,
      hasPermissionsToUpgrade,
      hasExpiredLicense,
      activeUser,
    } = this.props;
    const gridProps = {};
    if (plan !== undefined) {
      if (plan.availableUpgrade && hasPermissionsToUpgrade) {
        gridProps.upgrading = true;
        gridProps.selected = plan.type;
        gridProps.hasExpiredLicense = hasExpiredLicense;
      } else {
        gridProps.hideButtons = true;
      }
    }
    if (!activeUser) gridProps.showBuyButtons = true;
    return (
      <main className="Page__content">
        <ContentFrame pageType="pricing">
          <PageHeader
            title={<ConnectedFormattedMessage id="pricing_page.title" />}
            description={
              <ConnectedFormattedMessage id="pricing_page.description" />
            }
            type="pricing"
          />
          <PricingGrid options={pricingOptions} {...gridProps} />
          <PricingFeatures />
        </ContentFrame>
      </main>
    );
  }
}

PricingPage.propTypes = {
  plan: PropTypes.object,
  location: PropTypes.shape({
    state: PropTypes.shape({
      static: PropTypes.bool,
    }),
  }),
  hasPermissionsToUpgrade: PropTypes.bool,
  hasExpiredLicense: PropTypes.bool,
};

const mapStateToProps = state => {
  const licenses = getActiveSchoolLicense(state);
  const expiredLoginVars = getFailedLoginErrorVars(state);
  const activeUser = getActiveUser(state);
  let plan =
    licenses && licenses.length > 0
      ? getPlanByLicense(licenses[0].license_type)
      : undefined;
  if (expiredLoginVars.license)
    plan = getPlanByLicense(expiredLoginVars.license.license_type);
  const hasExpiredLicense = Object.keys(expiredLoginVars).length > 0;
  const hasPermissionsToUpgrade =
    (activeUser && activeUser.isAdmin) || hasExpiredLicense;
  return {
    plan,
    hasPermissionsToUpgrade,
    hasExpiredLicense,
    activeUser,
  };
};

export default connect(mapStateToProps, { sendAnalyticsEventById })(
  PricingPage
);
